var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniAreaverdeResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ft4rbfpcga",
    width: 17,
    height: 22,
    x: 12,
    y: 9,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 9h16.522v22H12V9z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ft4rbfpcga)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M22.847 25.109h1.544c2.281 0 4.131-1.85 4.131-4.13 0-2.232-1.77-4.045-3.984-4.123.885-.38 1.505-1.257 1.505-2.28 0-1.368-1.109-2.478-2.478-2.478-.343 0-.669.07-.966.197.09-.256.141-.53.141-.816 0-1.37-1.11-2.48-2.479-2.48s-2.478 1.11-2.478 2.48c0 .286.05.56.14.816-.297-.127-.624-.197-.967-.197-1.368 0-2.478 1.11-2.478 2.478 0 1.023.62 1.9 1.505 2.28-2.212.078-3.984 1.89-3.984 4.123 0 2.28 1.85 4.13 4.131 4.13h3.324v3.963h-4.583c-.532 0-.963.432-.963.964s.431.964.963.964h11.093c.533 0 .964-.432.964-.964s-.43-.964-.964-.964h-4.582v-3.963h1.465z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniAreaverdeResting);
export default __webpack_public_path__ + "static/media/icon_mini_areaverde_resting.3db7bbfa29c81de7b921a7b530860316.svg";
export { ForwardRef as ReactComponent };